var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.renderComponent)?_c('div',{attrs:{"id":"eventList"}},[_c('sideBar',{attrs:{"isChange":_vm.isChange}}),(_vm.checkMobileStatus)?_c('div',{staticClass:"mobile-event-header-container"},[_c('h4',[_vm._v(_vm._s(_vm.lang("Event")))])]):_vm._e(),_c('div',{staticClass:"content-body-container",class:( _vm.schoolID === 'SCH201400000480'
        || _vm.schoolID === 'SCH201400000497'
        || _vm.schoolID === 'SCH201400000501'
        || _vm.schoolID === 'SCH201400000510'
        || _vm.schoolID === 'SCH201500000032'
        || _vm.schoolID === 'SCH201500000054'
        || _vm.schoolID === 'SCH201500000074'
        || _vm.schoolID === 'SCH201400000541'
        || _vm.schoolID === 'SCH201400000553'
        || _vm.schoolID === 'SCH201400000471' || (_vm.isParent === 'Parent' && _vm.parentSchIds.includes('SCH201400000480')) ) ? 'col-md-8' : 'col-md-11'},[_c('eventCom')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }